/** @format */

import { Button, Form, InputNumber, Modal } from "antd";
import { useCallback, useEffect } from "react";

type ModalAlokasiBosType = {
  openModal: any;
  dataMadrasah: any;
  provinsi: any;
  kabkota: any;
  handleClose: () => void;
  handleSave: (values: any) => void;
};

export const ModalAlokasiBos = ({
  openModal,
  dataMadrasah,
  provinsi,
  kabkota,
  handleClose,
  handleSave,
}: ModalAlokasiBosType) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (!dataMadrasah) return;
    form.setFieldsValue({
      tahap1: dataMadrasah?.apbn_bos_semester1,
      tahap2: dataMadrasah?.apbn_bos_semester2,
      triwulan1: dataMadrasah?.apbn_bos_triwulan1,
      triwulan2: dataMadrasah?.apbn_bos_triwulan2,
      triwulan3: dataMadrasah?.apbn_bos_triwulan3,
      triwulan4: dataMadrasah?.apbn_bos_triwulan4,
    });
  }, [dataMadrasah, form]);

  const handleReset = useCallback(() => {
    handleClose();
    form.resetFields();
  }, [form, handleClose]);

  const checkValidationSaldo = (_, values) => {
    if (values <= 0) {
      return Promise.reject("Saldo alokasi tidak boleh 0!");
    }
    return Promise.resolve();
  };
  return (
    <Modal
      open={openModal}
      width={1000}
      title={`Alokasi Dana BOS`}
      onCancel={handleReset}
      footer={[
        <Button key="balokasi" onClick={handleReset}>
          Batal
        </Button>,
        <Button key="bsalokasi" type="primary" onClick={() => form.submit()}>
          Simpan
        </Button>,
      ]}>
      <Form
        form={form}
        name="formPencairan"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 8 }}
        labelAlign="left"
        labelWrap
        layout="horizontal"
        onFinish={handleSave}>
        <Form.Item label="NSM">{dataMadrasah?.nsm || ""}</Form.Item>
        <Form.Item label="Madrasah">
          {dataMadrasah?.namaMadrasah || ""}
        </Form.Item>
        <Form.Item label="Jenjang">
          <div className="uppercase">{dataMadrasah?.jenjang || ""}</div>
        </Form.Item>
        <Form.Item label="Jumlah Siswa">
          {dataMadrasah?.jumlahSiswa || ""}
        </Form.Item>
        <Form.Item label="Provinsi">
          {provinsi.find((item) => item.kode === dataMadrasah?.kodeProvinsi)
            ?.nama || ""}
        </Form.Item>
        <Form.Item label="Kabkota">
          {kabkota.find((item) => item.kode === dataMadrasah?.kodeKabKota)
            ?.nama || ""}
        </Form.Item>
        <Form.Item
          label="Semester 1"
          name="tahap1"
          rules={[
            {
              required: true,
              message: "Nilai Tahap 1 tidak boleh kosong!",
            },
            {
              validator: checkValidationSaldo,
            },
          ]}>
          <InputNumber
            style={{ width: "100%" }}
            maxLength={15}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            prefix="Rp."
            placeholder="Nilai Tahap 1"
          />
        </Form.Item>
        <Form.Item
          label="Semester 2"
          name="tahap2"
          rules={[
            {
              required: true,
              message: "Nilai Tahap 2 tidak boleh kosong!",
            },
            {
              validator: checkValidationSaldo,
            },
          ]}>
          <InputNumber
            style={{ width: "100%" }}
            maxLength={15}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            prefix="Rp."
            placeholder="Nilai Tahap 2"
          />
        </Form.Item>
        <Form.Item
          label="Triwulan 1"
          name="triwulan1"
          rules={[
            {
              required: true,
              message: "Nilai Triwulan 1 tidak boleh kosong!",
            },
            {
              validator: checkValidationSaldo,
            },
          ]}>
          <InputNumber
            style={{ width: "100%" }}
            maxLength={15}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            prefix="Rp."
            placeholder="Nilai Triwulan 1"
          />
        </Form.Item>
        <Form.Item
          label="Triwulan 2"
          name="triwulan2"
          rules={[
            {
              required: true,
              message: "Nilai Triwulan 2 tidak boleh kosong!",
            },
            {
              validator: checkValidationSaldo,
            },
          ]}>
          <InputNumber
            style={{ width: "100%" }}
            maxLength={15}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            prefix="Rp."
            placeholder="Nilai Triwulan 2"
          />
        </Form.Item>
        <Form.Item
          label="Triwulan 3"
          name="triwulan3"
          rules={[
            {
              required: true,
              message: "Nilai Triwulan 3 tidak boleh kosong!",
            },
            {
              validator: checkValidationSaldo,
            },
          ]}>
          <InputNumber
            style={{ width: "100%" }}
            maxLength={15}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            prefix="Rp."
            placeholder="Nilai Triwulan 3"
          />
        </Form.Item>
        <Form.Item
          label="Triwulan 4"
          name="triwulan4"
          rules={[
            {
              required: true,
              message: "Nilai Triwulan 4 tidak boleh kosong!",
            },
            {
              validator: checkValidationSaldo,
            },
          ]}>
          <InputNumber
            style={{ width: "100%" }}
            maxLength={15}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            prefix="Rp."
            placeholder="Nilai Triwulan 4"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
